import { useCallback } from 'react';
import useSWR, { mutate } from 'swr';
import { sdk } from 'sdk';
import { revalidateOptions } from 'frontastic';
import { UseProjectBuilderReturn } from './types';

const useProjectBuilder = (): UseProjectBuilderReturn => {
  const extensions = sdk.composableCommerce;

  const shoppingListResults = useSWR('/action/projectBuilder/getShoppingLists', extensions.projectBuilder.getMyProjects, {
    revalidateOptions,
    revalidateIfStale: true,
  });

  const shoppingLists = shoppingListResults.isLoading
    ? { loading: true }
    : shoppingListResults.data?.isError
    ? { loading: false, error: true }
    : { loading: false, data: shoppingListResults.data?.data?.data };

  const getMyProjectsDashboard = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.getMyProjectsDashboard(payload);

    return res.isError ? {} : res.data;
  }, []);

  const getProjectById = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.getProjectById(payload);

    return res.isError ? {} : res.data;
  }, []);

  const performMutationOnMyProjectById = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.performMutationOnMyProjectById(payload);

    return res.isError ? {} : res.data;
  }, []);

  const deleteProject = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.deleteProject(payload);
    if (res.isError) {
      throw new Error(res.error.message || 'Failed to delete project');
    }
    return res.data;
  }, []);

  const createShoppingList = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.createShoppingList(payload);
    if (res.isError) {
      throw new Error(res.error.message || 'Failed to create project');
    }
    return res.data;
  }, []);

  const updateShoppingList = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.updateShoppingList(payload);
    if (res.isError) {
      throw new Error(res.error.message || 'Failed to update project');
    }
    mutate('/action/projectBuilder/getShoppingLists');
    return res.data;
  }, []);
  const updateProjectStatus = useCallback(async (payload: any) => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.updateProjectStatus(payload);
    if (res.isError) {
      throw new Error(res.error.message || 'Failed to update project');
    }
    return res.data;
  }, []);
  const getShoppingLists = useCallback(async () => {
    const extensions = sdk.composableCommerce;
    const res = await extensions.projectBuilder.getShoppingLists({});

    return res.isError ? {} : res.data;
  }, []);

  return {
    createShoppingList,
    updateShoppingList,
    shoppingLists,
    getMyProjectsDashboard,
    getProjectById,
    performMutationOnMyProjectById,
    deleteProject,
    updateProjectStatus,
    getShoppingLists,
  };
};

export default useProjectBuilder;
